const Permissions = {
  ACCESS_FILE: 'ACCESS_FILE',
  VIEW_PRODUCT: 'VIEW_PRODUCT',
}
export default Permissions